<template>
  <div class="wrapper content-page">
    <div class="content-body">
      <navigation></navigation>
      <div class="content-view">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import navigation from "../components/theNavigation";
export default {
  name: "Dashboard",
  components: {
    navigation
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  max-width: 1400px;
  margin: 0 auto;
}
.content-body {
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.5);
  padding: 30px;
  margin: 20px;
}

.content-view {
  height: calc(100vh - 250px);
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
